import {Directive, EventEmitter, HostListener, Input, Output} from '@angular/core';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ConfirmDialogComponent} from "@shared/components/confirm-dialog/confirm-dialog.component";

@Directive({
    standalone: true,
    selector: '[confirmModal]'
})
export class ConfirmDialogDirective {
    @Input() confirmMessage = 'Are you sure?';
    @Input('confirmModal') confirmTitle = 'Confirm';
    @Input() confirmOk = 'Yes';
    @Input() confirmCancel = 'No';
    // UNIVAPLAT-3028: per-usage button color override. Defaults preserve the
    // existing red/grey styling for every other confirmModal usage — only the
    // "Turn to dynamic" dialog in admin-dashboard.page.html passes these.
    @Input() confirmOkClass = 'btn-danger';
    @Input() confirmCancelClass = 'btn-secondary';

    // UNIVAPLAT-3499: opt-in cancel-first button order (default keeps the existing order).
    @Input() confirmCancelFirst = false;

    // UNIVAPLAT-3499: opt-in header text. When set, the dialog header is this text and the
    // confirmModal title moves into the body as the description (default off: unchanged).
    @Input() confirmHeader?: string;

    @Output() confirmedClick = new EventEmitter<void>();

    constructor(private modalService: NgbModal) {}

    @HostListener('click', ['$event'])
    async onClick(event: Event) {
        event.preventDefault();
        event.stopPropagation();

        const modalRef = this.modalService.open(ConfirmDialogComponent, {
            size: "sm",
            centered: true,
            backdrop: 'static',
            ...(this.confirmHeader
                ? {ariaLabelledBy: 'confirm-dialog-title', ariaDescribedBy: 'confirm-dialog-description'}
                : {})
        });
        modalRef.componentInstance.title = this.confirmTitle;
        modalRef.componentInstance.message = this.confirmMessage;
        modalRef.componentInstance.confirmText = this.confirmOk;
        modalRef.componentInstance.cancelText = this.confirmCancel;
        modalRef.componentInstance.confirmOkClass = this.confirmOkClass;
        modalRef.componentInstance.confirmCancelClass = this.confirmCancelClass;

        modalRef.componentInstance.cancelFirst = this.confirmCancelFirst;
        modalRef.componentInstance.header = this.confirmHeader;

        const ok = await modalRef.result.catch(() => false);

        if (ok) {
            this.confirmedClick.emit();
        }
    }
}
